var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._b({staticClass:"btn btn-circle btn-export-csv rounded-pill tw-flex align-items-center",on:{"click":_vm.tryToExport}},'button',_vm.$attrs,false),[(!_vm.isExporting)?_c('span',[_vm._v("EXPORT")]):_c('span',[_vm._v("EXPORTING...")]),_c('ExternalLinkIcon',{staticClass:"right-icon tw-ml-3 float-right",attrs:{"size":"1x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }